import api from 'api'

type AnnotateCompanyFileResponse = {
  id: number
  path: string
  type: string
  tempUrl: string
  extra?: Record<string, unknown>
}

export async function annotateCompanyFile(
  companyId: number,
  fileId: number,
  schema: Record<string, unknown>
) {
  const response = await api.patch<AnnotateCompanyFileResponse>(
    `/admin/company/${companyId}/files/${fileId}`,
    schema
  )
  return response.data
}
